<template>
    <ui-section title="Ordem das paradas" description="Arraste para mudar a ordem ou passar o caso para outra equipe. Reotimize para voltar à menor distância.">
        <div v-for="team in editor.teams" :key="`order-${team.key}`" class="pe-order">
            <div class="pe-order__head">
                <i class="pe-dot" :style="{ background: team.color }"></i>
                <strong>{{ team.name }}</strong>
                <span class="ui-small ui-muted">{{ team.manual_order ? "ordem ajustada à mão" : "ordem otimizada" }}</span>
                <v-spacer></v-spacer>
                <v-btn v-if="$allowed('edit')" x-small text :disabled="!team.manual_order" @click="editor.optimizeTeam(team)">Reotimizar</v-btn>
            </div>
            <div v-if="editor.planOf(team)" class="pe-order__base"><span class="pe-badge pe-badge--base">B</span>{{ editor.planOf(team).base.name }} — saída</div>
            <draggable :list="editor.orderLists[team.key] || []" group="trip-order" handle=".pe-handle" class="pe-order__list" ghost-class="pe-ghost" @change="editor.scheduleApply('order', team.key)">
                <div v-for="(caseId, index) in editor.orderLists[team.key] || []" :key="caseId" class="pe-order__item">
                    <v-icon small class="pe-handle">mdi-drag-vertical</v-icon>
                    <span class="pe-badge" :style="{ background: team.color }">{{ index + 1 }}</span>
                    <div class="pe-order__main">
                        <span>{{ editor.caseName(caseId) }}</span>
                        <div class="ui-small ui-muted">{{ editor.caseCity(caseId) }}<span v-if="editor.legBefore(team, index)"> · {{ editor.legBefore(team, index) }}</span></div>
                    </div>
                </div>
                <div v-if="!(editor.orderLists[team.key] || []).length" class="pe-order__empty ui-small ui-muted">Arraste casos para cá ou inclua pelo mapa.</div>
            </draggable>
            <div v-if="editor.planOf(team) && editor.form.options.round_trip && editor.planOf(team).legs.length" class="pe-order__base">
                <span class="pe-badge pe-badge--base">B</span>{{ editor.planOf(team).base.name }} — retorno <span v-if="editor.returnText(team)" class="ui-small ui-muted">· {{ editor.returnText(team) }}</span>
            </div>
        </div>
    </ui-section>
</template>

<script>
import draggable from "vuedraggable";

// Editor de roteiro: Ordem das paradas de cada equipe: arrastar para reordenar ou passar o caso para outra equipe.
// O estado e os metodos ficam no ProspectTripEditor (inject "editor").
export default {
    name: "ProspectTripStops",
    components: { draggable },
    inject: ["editor"],
};
</script>
